document.addEventListener("DOMContentLoaded", () => {
  const breadcrumbContainer = document.querySelector(".breadcrumbs");
  if (!breadcrumbContainer) return;

  breadcrumbContainer.innerHTML = "";

  const createLink = (href, text) => {
    const a = document.createElement("a");
    a.href = href;
    a.textContent = text;
    a.draggable = false;
    return a;
  };

  const createSeparator = () => {
    const sep = document.createElement("p");
    sep.textContent = ">";
    return sep;
  };

  breadcrumbContainer.appendChild(createLink("/", "Home"));

  const rawSegments = window.location.pathname.split("/").filter(Boolean);
  const hasCategory = rawSegments.includes("category");

  const segments = rawSegments.filter(
    (seg) => seg.toLowerCase() !== "category"
  );

  let path = "";

  segments.forEach((segment, index) => {
    const isBlogRoot = segments[0] === "blog";
    const isLast = index === segments.length - 1;
    const isBlogPostNoCategory =
      isBlogRoot && !hasCategory && segments.length > 1;

    if (isBlogPostNoCategory && index > 0) return;

    breadcrumbContainer.appendChild(createSeparator());

    path += `/${segment}`;

    const name = segment
      .replace(/-/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());

    if (isLast && hasCategory) {
      const lastCrumb = document.createElement("p");
      lastCrumb.textContent = name;
      breadcrumbContainer.appendChild(lastCrumb);
    } else {
      breadcrumbContainer.appendChild(createLink(path, name));
    }
  });
});
